import { T } from 'react-translator-component';

import { Tone, TONES } from './ocpiHelpers';

interface Props {
  label: string;
  tone: Tone;
}

/** Status sempre em texto e cor: o texto carrega o dado, a cor só reforça. */
const StatusTag = ({ label, tone }: Props) => (
  <span
    style={{
      display: 'inline-flex',
      alignItems: 'center',
      gap: 6,
      padding: '2px 8px',
      borderRadius: 8,
      fontSize: 12,
      fontWeight: 500,
      background: TONES[tone].bg,
      color: TONES[tone].fg,
      whiteSpace: 'nowrap',
    }}
  >
    <span style={{ width: 6, height: 6, borderRadius: '50%', background: TONES[tone].fg }} />
    {T(label)}
  </span>
);

export default StatusTag;
